import { getCookieByName } from '../utils/functions';
import { useSelector } from 'react-redux';

export function useEnableVisionCareInsurance() {
  const eligibleForInsuranceCookie = getCookieByName(
    'eligibleForInsurance',
    true
  );
  const eligibleForInsurance = useSelector(
    (state: any) => state.workflow.flowDefiningAttributes?.eligibleForInsurance
  );

  if (eligibleForInsuranceCookie !== null) {
    return eligibleForInsuranceCookie as boolean;
  }

  if (eligibleForInsurance !== null && eligibleForInsurance !== undefined) {
    return eligibleForInsurance as boolean;
  }

  return false;
}
